<fa-icon [icon]="faSort" *ngIf="arrowMode === 'BASE'" />
<fa-icon [icon]="faSortAsc" *ngIf="arrowMode === 'ASC'" />
<fa-icon [icon]="faSortDesc" *ngIf="arrowMode === 'DESC'" />
